import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { InstagramLogo, TwitterLogo, Envelope } from "@phosphor-icons/react";
import API from "../lib/api";

export default function Footer() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    API.get("/categories")
      .then(r => setCategories(Array.isArray(r.data) ? r.data : []))
      .catch(err => console.error("Failed to load footer categories:", err));
  }, []);

  return (
    <footer className="bg-[#050505] border-t border-white/5 pt-24 pb-12" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-20">
          {/* Brand */}
          <div className="md:col-span-2">
            <h2 className="font-['Cormorant_Garamond'] text-4xl font-light text-[#FDFBF7] mb-4">
              Lead<span className="text-[#D4AF37]">.</span>Serve<span className="text-[#D4AF37]">.</span>Slay
            </h2>
            <p className="text-[#A1A1AA] text-sm leading-relaxed max-w-md font-light">
              Luxury leadership. Soft power. Unforgettable presence. By La'Daena Londo.
            </p>
            <div className="flex gap-6 mt-8">
              <a href="#" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors duration-300" data-testid="footer-instagram">
                <InstagramLogo size={20} weight="thin" />
              </a>
              <a href="#" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors duration-300" data-testid="footer-twitter">
                <TwitterLogo size={20} weight="thin" />
              </a>
              <a href="#" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors duration-300" data-testid="footer-email">
                <Envelope size={20} weight="thin" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] font-medium mb-6">Shop</h3>
            <ul className="space-y-3">
              {categories.map(cat => (
                <li key={cat.slug}><Link to={`/shop?category=${encodeURIComponent(cat.slug)}`} className="text-[#A1A1AA] text-sm hover:text-[#FDFBF7] transition-colors duration-300 font-light">{cat.name}</Link></li>
              ))}
              <li><Link to="/shop" className="text-[#A1A1AA] text-sm hover:text-[#FDFBF7] transition-colors duration-300 font-light">All Products</Link></li>
            </ul>
          </div>

          {/* Info */}
          <div>
            <h3 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] font-medium mb-6">Info</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-[#A1A1AA] text-sm hover:text-[#FDFBF7] transition-colors duration-300 font-light">About Us</Link></li>
              <li><Link to="/auth" className="text-[#A1A1AA] text-sm hover:text-[#FDFBF7] transition-colors duration-300 font-light">My Account</Link></li>
              <li><a href="#" className="text-[#A1A1AA] text-sm hover:text-[#FDFBF7] transition-colors duration-300 font-light">Shipping</a></li>
              <li><a href="#" className="text-[#A1A1AA] text-sm hover:text-[#FDFBF7] transition-colors duration-300 font-light">Returns</a></li>
              <li><a href="#" className="text-[#A1A1AA] text-sm hover:text-[#FDFBF7] transition-colors duration-300 font-light">Contact</a></li>
            </ul>
          </div>
        </div>

        {/* Giant brand footer */}
        <div className="border-t border-white/5 pt-12">
          <p className="font-['Cormorant_Garamond'] text-6xl md:text-8xl lg:text-9xl font-light text-white/[0.03] text-center tracking-tighter select-none">
            LEAD.SERVE.SLAY
          </p>
          <p className="text-center text-[#A1A1AA] text-xs tracking-wide mt-4 font-light">
            &copy; {new Date().getFullYear()} Lead.Serve.Slay&trade; by La'Daena Londo. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
